module.exports = "<base-container :title=\"$t(lblSetting.contactTitle)\">\n  <img src=\"../../../static/contact.png\" width=\"80%\">\n</base-container>\n";


//////////////////
// WEBPACK FOOTER
// ./src/containers/contact/template.html
// module id = JSQC
// module chunks = 0